const theme = {
  colors: {
    white: "#fff",
    black: "#000",
    brandSuccess: "#a6c733",
    brandInfo: "#57bdda",
    brandWarning: "#e5c649",
    brandDanger: "#d22e2e ",
    primary: "#0D5229", //Verde
    tertiary: "#636466",
    secondary: "#2A844E",
    borderGradient: "conic-gradient(from 90deg at 50% 50%, #2A844E 0deg, #0D5229 91.73076510429382deg, #4DE889 190.38461208343506deg, #2A844E 289.03846979141235deg, #0D5229 360deg)",
    disabledDaysWeek: "#efeded",
    alert: "#FF6E28", // Laranja
    placeholder: "#C7C7C7",
    elements: "#E0E0E0",
    modal: "#FAFAFA",
    background2: "#f6f6f6",
    mockup: "#D9D9D9",
    skeleton1: "#f5f5f5",
    skeleton2: "#ddd",
    disable: "#626262",
    neutral: '#EAEAEA',
    dashBorderDown: '#C92A2A',
    dashBorderUp: '#34C759',
    dashBgDown: '#FFE3E3',
    dashBgUp: '#F0FDF4'
  },
};

export default theme;
